export default class ListGroupController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    GroupService,
    groups
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.GroupService = GroupService;
    this.groups = groups;
  }

  addGroup(ev) {
    const confirm = this.$mdDialog.prompt()
      .title('Dodaj nową grupę')
      .textContent('Wpisz nazwę swojej nowej grupy.')
      .placeholder('Wpisz nazwę')
      .ariaLabel('Wpisz nazwę')
      .targetEvent(ev)
      .multiple(true)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      const group = {name: result};
      this.GroupService.addGroup(group).then(groupId => {
        group.id = groupId;
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano grupę')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    });
  }

  editGroup(groupId, ev) {
    const groupToEdit = this.groups.filter(item => item.id === groupId)[0];
    const confirm = this.$mdDialog.prompt()
      .title('Edytuj grupę')
      .textContent('Zmień nazwę grupy.')
      .placeholder('Wpisz nową nazwę')
      .ariaLabel('Wpisz nową nazwę')
      .initialValue(groupToEdit.name)
      .targetEvent(ev)
      .multiple(true)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      groupToEdit.name = result;
      this.GroupService.editGroup(groupToEdit).then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie zmieniono nazwę grupy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    });
  }

  removeGroup(groupId, ev) {
    ev.stopPropagation();
    this.GroupService.deleteGroup(groupId).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto grupę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
